import { createFileRoute } from '@tanstack/react-router'
import { FundamentalsIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fundamentals/')({
  loader: () => loadPageData({ data: { kind: 'fundamentals', locale: 'en' } }),
  head: () => staticRouteHead('fundamentals', 'en'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <FundamentalsIndexPage />
    </CatalogProvider>
  )
}
